<router-outlet></router-outlet>
<app-loader></app-loader>
<div
  *ngIf="!isPublicRoute"
  class="addToHomeScreen"
  [style.maxHeight]="beforeinstallpromptEvent ? '150px' : '0px'"
  [style.visibility]="beforeinstallpromptEvent ? 'visible' : 'hidden'"
>
  <div class="addToHomeScreenContainer">
    <i class="fa-regular fa-circle-question"></i>
    {{ "app.install.prompt" | translate }}
    <div class="buttons">
      <p-button
        size="small"
        icon="pi pi-check"
        (click)="beforeinstallpromptEvent.prompt()"
        [label]="'app.install.yes' | translate"
      />
      <p-button size="small" icon="pi pi-times" (click)="dismissPWAInstall()" [label]="'app.install.no' | translate" />
    </div>
  </div>
</div>
<div *ngIf="beforeinstallpromptEvent && !isPublicRoute" style="height: 120px"></div>
